import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-seo-off-page-backlinks-form',
  templateUrl: './seo-off-page-backlinks-form.component.html',
  styleUrls: ['./seo-off-page-backlinks-form.component.css'],
})
export class SeoOffPageBacklinksFormComponent {
  url: string = 'seoBacklinks';
  id!: string;
  form!: FormGroup;
  isViewOnly: boolean = true;

  relTypes = [
    { value: 'dofollow', label: 'DoFollow' },
    { value: 'nofollow', label: 'NoFollow' },
    { value: 'sponsored', label: 'Sponsored' },
    { value: 'ugc', label: 'UGC' },
    { value: 'unknown', label: 'Unknown' },
  ];

  linkPlacements = [
    { value: 'body', label: 'Body' },
    { value: 'author_bio', label: 'Author Bio' },
    { value: 'directory_profile', label: 'Directory Profile' },
    { value: 'footer', label: 'Footer' },
    { value: 'sidebar', label: 'Sidebar' },
    { value: 'other', label: 'Other' },
  ];

  backlinkStatuses = [
    { value: 'pending', label: 'Pending' },
    { value: 'live', label: 'Live' },
    { value: 'lost', label: 'Lost' },
    { value: 'rejected', label: 'Rejected' },
  ];

  acquisitionTypes = [
    { value: 'outreach', label: 'Outreach' },
    { value: 'citation', label: 'Citation' },
    { value: 'guest_post', label: 'Guest Post' },
    { value: 'pr', label: 'PR' },
    { value: 'natural', label: 'Natural' },
    { value: 'other', label: 'Other' },
  ];

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      if (this.id) {
        this.getData();
      }
    });
    this.form.disable();
  }

  initForm(): void {
    this.form = this.fb.group({
      sourceDomain: [''],
      sourceUrl: [''],
      targetUrl: [''],
      anchorText: [''],
      relType: ['unknown'],
      linkPlacement: ['other'],
      backlinkStatus: ['pending'],
      firstSeenAt: [null],
      lastSeenAt: [null],
      authorityScore: [0],
      relevanceScore: [0],
      spamRisk: [0],
      acquisitionType: ['other'],
      notes: [''],
    });
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      console.log('response', response);
      const data = response.data;
      this.form.patchValue({
        sourceDomain: data.sourceDomain,
        sourceUrl: data.sourceUrl,
        targetUrl: data.targetUrl,
        anchorText: data.anchorText,
        relType: data.relType,
        linkPlacement: data.linkPlacement,
        backlinkStatus: data.backlinkStatus,
        firstSeenAt: data.firstSeenAt
          ? new Date(data.firstSeenAt).toISOString().substring(0, 10)
          : null,
        lastSeenAt: data.lastSeenAt
          ? new Date(data.lastSeenAt).toISOString().substring(0, 10)
          : null,
        authorityScore: data.authorityScore,
        relevanceScore: data.relevanceScore,
        spamRisk: data.spamRisk,
        acquisitionType: data.acquisitionType,
        notes: data.notes,
      });
    });
  }

  goBack(): void {
    this.router.navigateByUrl('marketing/seo/offPageBacklinks');
  }
}
